import * as React from 'react';

import type {UserEmail} from 'nutshell-graphql-types';

import {EmailWidgetGoogle} from './email-widget-google';
import {EmailWidgetOffice365} from './email-widget-office365';
import {EmailWidgetSmtp} from './email-widget-smtp';

type Props = {
    email: UserEmail;
    isVerificationPollTimedOut: boolean;
    retryVerification: () => Promise<any>;
    onAuthStart: () => void;
    onAuthSuccess: () => Promise<any>;
    onAuthError: (arg1: string[]) => void;
};

export function EmailWidget(props: Props) {
    const {email, ...restProps} = props;
    switch (props.email.type) {
        case 'GOOGLE':
        case 'GOOGLE_APPS':
            return (
                <EmailWidgetGoogle
                    isEnabled={email.isEnabledForSending}
                    username={email.address}
                    externalService={props.email.type}
                    {...restProps}
                    errors={email.sendErrors}
                />
            );
        case 'OFFICE365':
            return (
                <EmailWidgetOffice365
                    isEnabled={email.isEnabledForSending}
                    username={email.address}
                    {...restProps}
                    errors={email.sendErrors}
                />
            );
        case 'SMTP':
            return <EmailWidgetSmtp email={email} {...restProps} />;
        default:
            return null;
    }
}
